import { useCallback, useEffect } from "react";

import { useApplicationContext } from "../../../providers/ApplicationContextProvider";
import { DashboardOpened } from "../../ampli";
import { useRecordEvent } from "./useRecordEvent";

export function useDashboardOpenedEvent() {
  const recordEvent = useRecordEvent(DashboardOpened);
  const { project, location } = useApplicationContext();

  const recordProjectContextEvent = useCallback(
    (projectId: string) =>
      recordEvent({
        route: "board_menu",
        project_id: projectId,
        project_type: project?.projectTypeKey,
        software_team_managed_project: project?.simplified,
      }),
    [project, recordEvent],
  );

  useEffect(() => {
    if (location.includes("planning-poker-project-view")) {
      project ? recordProjectContextEvent(String(project.id)) : recordEvent({ route: "board_menu" });
    } else {
      recordEvent({ route: "apps_menu" });
    }
  }, [location, project, recordEvent, recordProjectContextEvent]);
}
